<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.partner.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-end">
          <p class="caption mb-0">
            {{ 'pricing.partner.details.basicInfo' | translate }}
          </p>
          <button
            *appRequirePermission="'pricing.partner.actions'"
            class="icon-btn mb-1 me-1"
            placement="left"
            type="submit"
            triggers="hover"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            [ngbTooltip]="'pricing.partner.details.editCurrency' | translate"
            (click)="openCurrencyDialog($event)"
          >
            <i class="fa-light fa-euro-sign fa-sm"></i>
          </button>
        </div>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="row mb-3">
      <div class="col-12 col-md-6 row align-items-center mb-2">
        <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
          'pricing.partner.details.partnerName' | translate
        }}</label>
        <div class="col-12 col-sm-8">
          {{ pricingPartner()?.name }}
        </div>
      </div>
    </div>
    <ng-container *appRequirePermission="'pricing.partner.actions'">
      <div class="row mt-1">
        <p class="caption mb-0 col-9">
          {{ 'pricing.partner.details.addPrice' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      <app-bundle-price-form [partnerId]="partnerId()" />
    </ng-container>
    <div class="row mt-1">
      <p class="caption mb-0 col-9">
        {{
          'pricing.partner.details.titleBundles'
            | translate: { partner: pricingPartner()?.name }
        }}
      </p>
      <div
        class="col-3 text-end"
        *appRequirePermission="'pricing.partner.actions'"
      >
        <button
          *appRequirePermission="'pricing.partner.actions.approvePriceRequest'"
          type="button"
          class="icon-btn mb-1 me-1"
          [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
          [class.icon-btn-lg]="coreUtilsService.tabletMode()"
          (click)="approveAllPendingRequests($event)"
          [disabled]="!hasPendingPriceRequests()"
          data-cy="approve-all-price-requests-btn"
          placement="left"
          [ngbTooltip]="
            'pricing.partner.details.tooltips.approveAllPendingRequests'
              | translate
          "
        >
          <i class="fa-light fa-check-double fa-sm"></i>
        </button>
        <button
          type="button"
          class="icon-btn mb-1 me-1"
          [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
          [class.icon-btn-lg]="coreUtilsService.tabletMode()"
          (click)="openEditBundlesDialog($event)"
          data-cy="edit-bundles-btn"
          placement="left"
          [ngbTooltip]="'partnersPage.tooltips.editBundles' | translate"
        >
          <i class="fa-light fa-cube fa-sm"></i>
        </button>
        <button
          type="button"
          class="icon-btn dropdown-toggle px-1 mb-1 me-1"
          [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
          [class.icon-btn-lg]="coreUtilsService.tabletMode()"
          [disabled]="!pricingPartner()?.currency"
          [matMenuTriggerFor]="bulkEditMenu"
          data-cy="bulk-edit-prices-btn"
          placement="left"
          triggers="hover"
          [ngbTooltip]="'pricing.partner.details.bulkEditMenu' | translate"
        >
          <i class="fa-light fa-pencil fa-sm"></i>
        </button>
        <mat-menu #bulkEditMenu="matMenu">
          <button
            mat-menu-item
            size="small"
            data-cy="bulk-edit-wsp-btn"
            (click)="openBulkPriceDialog($event)"
          >
            {{ 'pricing.partner.details.bulkEdit.button' | translate }}
          </button>
          @if (!wspOnly()) {
            <button
              mat-menu-item
              size="small"
              data-cy="doctors-fee-prices-btn"
              (click)="openDoctorsFeeDialog($event)"
            >
              {{ 'pricing.partner.details.doctorsFee.button' | translate }}
            </button>
          }
        </mat-menu>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="row mb-3">
      <div class="col-12">
        <app-data-table [configuration]="bundleDataTableConfiguration()" />
      </div>
    </div>
    <div class="row mt-1">
      <p class="caption mb-0 col-9">
        {{
          'pricing.partner.details.titleDiscounts'
            | translate: { partner: pricingPartner()?.name }
        }}
      </p>
    </div>
    <hr class="mt-0" />
    <div class="row">
      <div class="col-12">
        <app-data-table [configuration]="discountDataTableConfiguration" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="modalRef.close()"
      data-cy="close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #priceColumnTemplate let-bundle="row">
  @if (
    bundle.discountedPrice !== undefined && bundle.discountedPrice !== null
  ) {
    <div class="caption">
      <span
        class="fw-bold text-success"
        triggers="hover"
        tooltipClass="discount-tooltip"
        [ngbTooltip]="discountTooltipTemplate"
        [tooltipContext]="{ bundle }"
      >
        {{ bundle.discountedPrice | number: '1.2-2' }}
        {{ pricingPartner()?.currency }}
      </span>
      <ng-container
        *ngTemplateOutlet="validFromTemplate; context: { bundle }"
      />
    </div>
  } @else {
    @if (bundle.pivot?.price) {
      <div class="caption">
        {{ bundle.pivot.price | number: '1.2-2' }}
        {{ pricingPartner()?.currency }}
        <ng-container
          *ngTemplateOutlet="validFromTemplate; context: { bundle }"
        />
      </div>
    } @else {
      <div class="caption text-danger">
        {{ 'pricing.partner.details.missingPrice' | translate }}
      </div>
    }
  }
</ng-template>

<ng-template #validFromTemplate let-bundle="bundle">
  @if (bundle.pivot?.validFrom) {
    <span class="text-muted">
      ({{ bundle.pivot.validFrom | date: 'dd.MM.yyyy' }})
    </span>
  }
</ng-template>

<ng-template #endUserPriceColumnTemplate let-bundle="row">
  @if (
    bundle.countryEupPrice !== null && bundle.countryEupPrice !== undefined
  ) {
    <div class="caption">
      @if (
        bundle.countryEupDiscountedPrice !== null &&
        bundle.countryEupDiscountedPrice !== undefined
      ) {
        <span
          class="fw-bold text-success"
          triggers="hover"
          tooltipClass="discount-tooltip"
          [ngbTooltip]="eupDiscountTooltipTemplate"
          [tooltipContext]="{ bundle }"
        >
          {{ bundle.countryEupDiscountedPrice | number: '1.2-2' }}
          {{ pricingPartner()?.currency }}
        </span>
      } @else {
        {{ bundle.countryEupPrice | number: '1.2-2' }}
        {{ pricingPartner()?.currency }}
      }
      @if (bundle.countryEupValidFrom) {
        <span class="text-muted">
          ({{ bundle.countryEupValidFrom | date: 'dd.MM.yyyy' }})
        </span>
      }
    </div>
  } @else {
    <div class="caption text-danger">
      {{ 'pricing.partner.details.missingEup' | translate }}
    </div>
  }
</ng-template>

<ng-template #eupDiscountTooltipTemplate let-bundle="bundle">
  (
  <span class="text-decoration-line-through">
    {{ bundle.countryEupPrice | number: '1.2-2' }}
    {{ pricingPartner()?.currency }}
  </span>
  @if (bundle.discount) {
    {{
      ', -' +
        (bundle.discount.valueType === ValueType.Percentage
          ? bundle.discount.discountValue + ' %'
          : (bundle.discount.discountValue | number: '1.2-2') +
            ' ' +
            pricingPartner()?.currency)
    }},
    {{
      'pricing.discount.list.discountType.' + bundle.discount.discountType
        | translate
    }}
    {{ 'pricing.discount.list.priceTypeTooltip.EUP' | translate }}
  }
  )
</ng-template>

<!-- Doctors fee is derived: country EUP - WSP (only when both exist). -->
<ng-template #doctorsFeeColumnTemplate let-bundle="row">
  @if (getDoctorsFee(bundle) !== null) {
    <div class="caption">
      {{ getDoctorsFee(bundle) | number: '1.2-2' }}
      {{ pricingPartner()?.currency }}
    </div>
  }
</ng-template>

<ng-template #bundleNameColumnTemplate let-bundle="row">
  <div class="caption" [class.price-request-bundle]="bundle.isPriceRequest">
    {{ getBundleDisplayName(bundle) }}
  </div>
</ng-template>

<ng-template #discountValueColumnTemplate let-discount="row">
  <div class="caption">
    {{ discount.discountValue }}
    {{
      discount.valueType === ValueType.Percentage
        ? '%'
        : pricingPartner()?.currency
    }}
  </div>
</ng-template>

<ng-template #bundlesColumnTemplate let-discount="row">
  @if (discount.discountType === DiscountType.General) {
    <span
      class="caption clickableColumn"
      triggers="hover"
      [ngbTooltip]="'pricing.discount.list.bundlesTooltip' | translate"
      (click)="openBundleListDialog($event, discount)"
    >
      {{ discount.bundleIds?.length }}
    </span>
  } @else {
    <span class="caption">
      {{ discount?.serviceDataReferenceKey }}
    </span>
  }
</ng-template>

<ng-template #generatedByColumnTemplate let-bundle="row">
  @if (bundle.pivot.generatedBy) {
    <span class="caption">
      <app-user-display [userId]="bundle.pivot.generatedBy" />
    </span>
  }
</ng-template>

<ng-template #lastStatusColumnTemplate let-discount="row">
  @if (discount.lastStatus === DiscountStatus.Approved) {
    <div class="caption text-success-vibrant">
      {{ 'pricing.discount.list.lastStatus.approved' | translate }}
    </div>
  } @else if (discount.lastStatus === DiscountStatus.Pending) {
    <div class="caption text-warning-vibrant">
      {{ 'pricing.discount.list.lastStatus.pending' | translate }}
    </div>
  }
</ng-template>

<ng-template #discountTooltipTemplate let-bundle="bundle">
  (
  <span class="text-decoration-line-through">
    {{ bundle.pivot.price | number: '1.2-2' }}
    {{ pricingPartner()?.currency }}
  </span>
  {{
    ', -' +
      (bundle.discount?.valueType === ValueType.Percentage
        ? bundle.discount?.discountValue + ' %'
        : (bundle.discount?.discountValue | number: '1.2-2') +
          ' ' +
          pricingPartner()?.currency)
  }},
  {{
    'pricing.discount.list.discountType.' +
      (bundle.discount?.discountType ?? null) | translate
  }}
  @if (bundle.discount?.priceType) {
    {{
      'pricing.discount.list.priceTypeTooltip.' + bundle.discount.priceType
        | translate
    }}
  }
  )
</ng-template>
